import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_SETTINGS_CONTEXT_SYMBOL = Symbol();
const useFormSettings = ()=>useImmutableContext(FORM_SETTINGS_CONTEXT_SYMBOL);
const useFormSettingsProvider = (...args)=>useImmutableContextProvider(FORM_SETTINGS_CONTEXT_SYMBOL, ...args);
export { useFormSettings, useFormSettingsProvider };
